import { useState, useContext, useEffect, useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { AccountContext } from '../../../../../GlobalContex';
import { Form } from 'react-bootstrap';
import styles from '../Shop.module.css';

export default function ShopSettings({ settings, currencies, onChange } = {}) {
    const { t } = useTranslation();
    const { account } = useContext(AccountContext);
    const $whatsAppPhone = useRef();
    const [whatsAppPhone, setWhatsAppPhone] = useState('');
    const [isValidWAPhone, setIsValidWAPhone] = useState(true);

    const onAttrChange = useCallback((e) => {
        if (!(onChange && e.target.validity.valid)) {
            return;
        }
        const { name, type, value, checked } = e.target;
        const prevValue = settings?.[name];
        const newValue = type === 'checkbox' ? checked : value;
        if (prevValue !== newValue) {
            const changes = { [name]: newValue };
            if (name === 'orderNotificationMethod') {
                if (newValue === 'WHATS_APP') {
                    setIsValidWAPhone($whatsAppPhone.current.validity.valid);
                } else if (prevValue === 'WHATS_APP') {
                    changes.whatsAppPhone = '';
                }
            }
            onChange(changes);
        }
    }, [onChange, settings]);

    const onKeyPress = useCallback((e) => {
        if (e.code === 'Enter') {
            onAttrChange(e);
        }
    }, [onAttrChange]);

    useEffect(() => setWhatsAppPhone(settings?.whatsAppPhone || ''), [settings?.whatsAppPhone]);
    useEffect(() => setIsValidWAPhone($whatsAppPhone.current.validity.valid), [whatsAppPhone]);

    return <>
        <Form.Group className="col-12 mb-3">
            <Form.Label>{t('Order Notification')}</Form.Label>
            <Form.Select name="orderNotificationMethod" value={settings?.orderNotificationMethod} onChange={onAttrChange}>
                <option value="EMAIL">{account?.email || 'test@email.com'}</option>
                <option value="WHATS_APP">WhatsApp</option>
            </Form.Select>
        </Form.Group>
        <Form.Group className="col-12 mb-3" style={{ display: settings?.orderNotificationMethod === 'WHATS_APP' ? 'block' : 'none' }}>
            <Form.Label className={isValidWAPhone ? '' : styles.isInvalidValue}>{t('WhatsApp Phone')}</Form.Label>
            <Form.Control
                ref={$whatsAppPhone}
                type="text"
                name="whatsAppPhone"
                onBlur={onAttrChange}
                pattern="\+([0-9][- ]?){6,14}[0-9]"
                onChange={(e) => setWhatsAppPhone(e.target.value)}
                isInvalid={!isValidWAPhone}
                onKeyPress={onKeyPress}
                value={whatsAppPhone}
                required
            />
        </Form.Group>
        <Form.Group className="col-12 mb-3">
            <Form.Label>{t('Currency')}</Form.Label>
            <Form.Select name="currency" value={settings?.currency} onChange={onAttrChange}>
                { currencies?.map((currency) => <option key={currency.code} value={currency.code}>({currency.code}) {currency.name}</option>) }
            </Form.Select>
        </Form.Group>
        <Form.Group className="col-12 mb-3">
            <Form.Check
                type="checkbox"
                name="showArchivedProducts"
                label={t('Show Archived Products')}
                checked={settings?.showArchivedProducts}
                onChange={onAttrChange}
            />
        </Form.Group>
    </>
}